import React, { Component } from 'react';
import { notification, Modal, Icon } from 'antd';
import styles from '../../_style/index.less';
import { dispatch, getState } from '@@/store';
import { fontEndConfig, showRecord } from '@/shared/utils';
import { jumpReport } from '@/shared/functions';
import Authorized from '@/components/Auth/auth';
import { dealCar } from '@/pages/CarManage/_components';
/**
 * desc 缓存各行form
 * 因表格固定列后 相当于拆分两个表格展示 导致 row 透传 form 不一致导致无法获取修改值
 * */
const formList = {};
export const getFormList = (key) => {
    return formList[key] || null;
};
export const setFormList = (key, val) => {
    formList[key] = val;
};
/**
 * desc 操作列
 * @params rowData:行数据
 * */
class TableCellOperate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: {
                basePriceY: {
                    label: '保留价',
                    unit: '元',
                },
                auctionPriceY: {
                    label: '起拍价',
                    unit: '元',
                },
                brokerage: {
                    label: '佣金',
                    unit: null,
                },
                commissionY: {
                    label: '服务费',
                    unit: '元',
                },
            },
        };
        this.isEdit = this.isEdit.bind(this);
        this.check = this.check.bind(this);
        this.save = this.save.bind(this);
        this.checkRepeat = this.checkRepeat.bind(this);
        this.renderOutOfStock = this.renderOutOfStock.bind(this);
        this.isRealOutOfStock = this.isRealOutOfStock.bind(this);
        this.isRealOutOfStock2min = this.isRealOutOfStock2min.bind(this);
        this.renderNormal = this.renderNormal.bind(this);
        this.darkOutOfStock = this.darkOutOfStock.bind(this);
        this.normalOutOfStock = this.normalOutOfStock.bind(this);
    }
    isEdit(key) {
        const { editingKey } = getState().session;
        const index = editingKey.findIndex((id) => id === key);
        return index !== -1;
    }
    check(data) {
        let result = {
            state: true,
        };
        Object.keys(data).forEach((key) => {
            const changeValue = Number(data[key]);
            switch (key) {
                // 保留价
                case 'basePriceY':
                    const auctionMode = this.props.td.sessionForm.getFieldsValue(['auctionMode'])['auctionMode'];
                    if (auctionMode === 1001) {
                        if (changeValue < Number(data['auctionPriceY'])) {
                            result = {
                                state: false,
                                msg: '保留价不能小于起拍价',
                            };
                        }
                    }
                    else {
                        if (changeValue !== 0 && changeValue && changeValue < Number(data['auctionPriceY'])) {
                            result = {
                                state: false,
                                msg: '保留价不能小于起拍价',
                            };
                        }
                    }
                case 'auctionPriceY':
                case 'brokerage':
                case 'commissionY':
                    if (!data[key]) {
                        data[key] = 0;
                    }
                    data[key] = changeValue;
                    break;
            }
        });
        return result;
    }
    checkRepeat(data) {
        const editedList = {};
        const { rowData } = this.props.td;
        Object.keys(data).forEach((key) => {
            const oldVal = Number(`${rowData[key]}`.split(',').join('')).toFixed(0);
            if (data[key] !== oldVal) {
                editedList[key] = data[key];
            }
        });
        return editedList;
    }
    save() {
        const { rowData } = this.props.td;
        const form = getFormList(rowData.goodsId);
        // const scrollTable = document.getElementsByClassName('ant-table-body')[0];
        // @ts-ignore
        // scrollTable.scrollLeft = 250;
        if (this.isEdit(rowData.goodsId) && form) {
            form.validateFields()
                .then((data) => {
                // desc 保存
                const noRepeatData = data;
                if (Object.keys(noRepeatData).length === 0) {
                    dispatch.session.delEditKey(rowData.goodsId);
                    return;
                }
                const checkResult = this.check(data);
                if (!checkResult.state) {
                    notification.warn({
                        message: checkResult.msg,
                    });
                    return false;
                }
                Modal.confirm({
                    centered: true,
                    content: (<div>
                {Object.keys(noRepeatData).map((key) => {
                        return (<div key={`edit_${key}`}>
                      <span style={{
                            display: 'inline-block',
                            width: 50,
                            textAlignLast: 'justify',
                        }}>
                        {this.state.list[key].label}
                      </span>
                      ：
                      <span key={`text${key}`}>{`${noRepeatData[key] || 0} ${this.state.list[key].unit}`}</span>
                    </div>);
                    })}
              </div>),
                    title: '是否确定修改为以下值：',
                    onOk: () => {
                        // ToDo 修改价格
                        dispatch.session.updatePrice(Object.assign(Object.assign({}, noRepeatData), { goodsId: rowData.goodsId }));
                        dispatch.session.delEditKey(rowData.goodsId);
                    },
                    onCancel: () => {
                        dispatch.session.delEditKey(rowData.goodsId);
                    },
                });
            })
                .catch((err) => {
                console.log('-------------------', err);
            });
        }
        else {
            dispatch.session.addEditKey(rowData.goodsId);
        }
    }
    normalOutOfStock() {
        const { editIndex } = getState().session;
        const { rowData } = this.props.td;
        editIndex ?
            notification.warn({
                message: '请先保存排序修改',
            }) :
            Modal.confirm({
                title: '是否确定下架该车辆？',
                onOk() {
                    dispatch.session.offShelf(rowData);
                },
            });
    }
    darkOutOfStock() {
        const { editIndex } = getState().session;
        const { rowData } = this.props.td;
        editIndex ?
            notification.warn({
                message: '请先保存排序修改',
            }) :
            Modal.confirm({
                title: '是否确定下架该车辆？',
                onOk() {
                    dispatch.session.setAuctionFailed(rowData.auctionId);
                },
            });
    }
    renderOutOfStock(beforeFn) {
        const { formData, roundStatus } = getState().session;
        const { auctionMode } = formData;
        const { rowData, index } = this.props.td;
        let outOfStock = () => {
        };
        switch (auctionMode) {
            case 2:
                outOfStock = roundStatus === 2 ? this.darkOutOfStock : this.normalOutOfStock;
                break;
            case 1011:
            case 1021:
                outOfStock = roundStatus === 5 ? this.darkOutOfStock : this.normalOutOfStock;
                break;
            default:
                outOfStock = this.normalOutOfStock;
        }
        return rowData.status === 0 && (<a onClick={() => {
            beforeFn ? beforeFn(outOfStock) : outOfStock();
        }} key={`OutOfStock_${index}`}>
        下架
      </a>);
    }
    setBrokerageType() {
        const { rowData } = this.props.td;
        const { list } = this.state;
        if (!list['brokerage']['unit']) {
            let str = '%';
            switch (rowData.brokerageTag) {
                case 0:
                case 2:
                    str = '元';
                    break;
                default:
                    break;
            }
            list['brokerage']['unit'] = str;
            setTimeout(() => {
                this.setState({
                    list,
                });
            });
        }
    }
    carMove(direction, beforeFn) {
        let moveDom;
        const { carData } = getState().session;
        const { index } = this.props.td;
        switch (direction) {
            case 'up':
                moveDom = (<a style={index === 0 ? {
                    color: 'rgba(0,140,255,0.5)',
                    cursor: 'not-allowed',
                } : {}} onClick={() => {
                    const upFn = () => {
                        index !== 0 && dispatch.session.moveGoods({
                            index,
                            direction: 'up',
                        });
                    };
                    beforeFn ? beforeFn(upFn) : upFn();
                }} key={`car_up_${index}`}>
            上移
          </a>);
                break;
            case 'down':
                const nextCar = carData[index + 1] || null;
                moveDom = (<a style={!(nextCar && nextCar.auctionStatus !== 7) ? {
                    color: 'rgba(0,140,255,0.5)',
                    cursor: 'not-allowed',
                } : {}} onClick={() => {
                    const downFn = () => {
                        (nextCar && nextCar.auctionStatus !== 7) && dispatch.session.moveGoods({
                            index,
                            direction: 'down',
                        });
                    };
                    beforeFn ? beforeFn(downFn) : downFn();
                }} key={`car_down_${index}`}>
            下移
          </a>);
                break;
            default:
                moveDom = (<span>{fontEndConfig.noValueReplace}</span>);
        }
        return moveDom;
    }
    carDel() {
        const { rowData, index } = this.props.td;
        return (<a onClick={() => {
            dispatch.session.delCarFromTable(rowData);
        }} key={`car_remove_${index}`}>
        移除
      </a>);
    }
    // desc 判断暗拍下架时 先判断是否距离结束大于2分钟，在判断最高价是否已超过保留价
    isRealOutOfStock(callback) {
        const { rowData } = this.props.td;
        dispatch.session.isTwoMinLeft({}).then((isMore) => {
            !isMore ? Modal.warn({
                title: '场次马上结束，不支持操作',
            }) : dispatch.session.checkCanOutOfStock({
                auctionId: rowData.auctionId,
            }).then((highter) => {
                highter ? Modal.confirm({
                    title: '该车辆出价已经超过保留价了，是否确定下架该车辆',
                    onOk: () => {
                        callback && callback();
                    },
                }) : callback && callback();
            });
        });
    }
    // desc 判断暗拍操作时 暗拍离结束是否大于2分钟
    isRealOutOfStock2min(callback, cancelFn) {
        dispatch.session.isTwoMinLeft({}).then((isMore) => {
            !isMore ? Modal.warn({
                title: '场次马上结束，不支持操作',
                onOk: () => {
                    cancelFn && cancelFn();
                },
            }) : callback && callback();
        });
    }
    renderSave(btnList = [], beforeFn) {
        const { rowData } = this.props.td;
        return (<React.Fragment>
        {this.isEdit(rowData.goodsId) ? (<div className={styles.tableSaveBtn} onClick={() => {
            const { rowData } = this.props.td;
            beforeFn ? beforeFn(this.save, () => {
                dispatch.session.delEditKey(rowData.goodsId);
            }) : this.save();
        }}>
              <Icon type="check-circle"/>
              <span style={{
            marginLeft: '8px',
        }}>
                保存
              </span>
            </div>) : (<React.Fragment>
              <a onClick={this.save}>
                编辑
              </a>
              {btnList}
            </React.Fragment>)}
      </React.Fragment>);
    }
    renderInAuction() {
        const { rowData } = this.props.td;
        const { formData, outOfStock } = getState().session;
        const { auctionMode } = formData;
        return rowData.auctionStatus === 7 ?
            (<span>{fontEndConfig.noValueReplace}</span>)
            : (<React.Fragment>
          {auctionMode === 1 && (rowData.isOperate ? this.renderSave([this.renderOutOfStock()]) :
                <span>{fontEndConfig.noValueReplace}</span>)}
          {(auctionMode === 2 || auctionMode === 1011 || auctionMode === 1021) && outOfStock && this.renderOutOfStock(this.isRealOutOfStock)}
          {(auctionMode === 2 || auctionMode === 1011 || auctionMode === 1021) && this.carMove('up', this.isRealOutOfStock2min)}
          {(auctionMode === 2 || auctionMode === 1011 || auctionMode === 1021) && this.carMove('down', this.isRealOutOfStock2min)}
          {auctionMode === 1001 && (rowData.isOperate ? this.renderSave([this.renderOutOfStock()]) :
                <span>{fontEndConfig.noValueReplace}</span>) // 竞拍中
            }
        </React.Fragment>);
    }
    renderPreAuction() {
        const { rowData } = this.props.td;
        const { formData } = getState().session;
        const { auctionMode } = formData;
        return rowData.auctionStatus === 7 ?
            (<span>{fontEndConfig.noValueReplace}</span>)
            : (<React.Fragment>
          {auctionMode === 1 && this.renderSave([this.renderOutOfStock(), this.carMove('up'), this.carMove('down')])}
          {auctionMode === 2 && this.renderSave([this.renderOutOfStock(), this.carMove('up'), this.carMove('down')])}
          {auctionMode === 1011 && this.renderSave([this.renderOutOfStock(), this.carMove('up'), this.carMove('down')])}
          {auctionMode === 1021 && this.renderSave([this.renderOutOfStock(), this.carMove('up'), this.carMove('down')])}
          {auctionMode === 1001 && this.renderSave([this.renderOutOfStock(), this.carMove('up'), this.carMove('down')])}
        </React.Fragment>);
    }
    renderNormal() {
        this.setBrokerageType();
        return this.renderSave([
            this.carDel(),
            this.carMove('up'),
            this.carMove('down'),
        ]);
    }
    renderSence() {
        const { roundStatus } = getState().session;
        return (<React.Fragment>
        {roundStatus === 1 && this.renderPreAuction() // 预展中
        }
        {roundStatus === 2 && this.renderInAuction() // 竞拍中
        }
        {roundStatus === 0 && this.renderNormal() // 待发拍
        }
      </React.Fragment>);
    }
    renderDark() {
        const { roundStatus, isDelayTender } = getState().session;
        const { rowData } = this.props.td;
        return (<React.Fragment>
        {roundStatus === 1 && this.renderPreAuction() // 预展中
        }
        {roundStatus === 2 && ((rowData.auctionStatus === 6 || rowData.auctionStatus === 5 || rowData.auctionStatus === 7 || rowData.auctionStatus === 50) ?
            <React.Fragment>
                {this.carMove('up', this.isRealOutOfStock2min)}
                {this.carMove('down', this.isRealOutOfStock2min)}
              </React.Fragment>
            : this.renderInAuction()) // 竞拍中
        }
        {roundStatus === 0 && this.renderNormal() // 待发拍
        }
        {roundStatus === 5 && (!isDelayTender ?
            (rowData.auctionStatus === 6 || rowData.auctionStatus === 5 || rowData.auctionStatus === 7 || rowData.auctionStatus === 50) ?
                <React.Fragment>
                  {this.carMove('up', this.isRealOutOfStock2min)}
                  {this.carMove('down', this.isRealOutOfStock2min)}
                </React.Fragment>
                :
                    rowData.auctionStatus === 9 ?
                        this.renderInAuction()
                        :
                            <span>{fontEndConfig.noValueReplace}</span>
            :
                <span>{fontEndConfig.noValueReplace}</span>)}
      </React.Fragment>);
    }
    renderCar() {
        const { roundStatus } = getState().session;
        return (<React.Fragment>
        {roundStatus === 1 && this.renderPreAuction() // 预展中
        }
        {roundStatus === 2 && this.renderInAuction() // 竞拍中
        }
        {roundStatus === 0 && this.renderNormal() // 待发拍
        }
      </React.Fragment>);
    }
    renderSession() {
        const { formData, superInDark } = getState().session;
        let operateDom;
        switch (formData.auctionMode) {
            case 2:
                operateDom = this.renderDark();
                break;
            case 1001:
                operateDom = this.renderCar();
                break;
            case 1011: // 超级拍（现场拍）
            case 1021: // 超级拍（车道拍）
                operateDom = superInDark ? this.renderDark() : this.renderDetail();
                break;
            default:
                operateDom = this.renderSence();
                break;
        }
        const children = operateDom.props.children || [];
        const hasBtn = children.filter((item) => {
            return item !== false;
        });
        return hasBtn.length > 0 ? operateDom : <span>{fontEndConfig.noValueReplace}</span>;
    }
    renderDetail() {
        const { rowData } = this.props.td;
        const { roundStatus } = getState().session;
        return (<div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        }}>
        {rowData.reportUrl && (<div>
              <a onClick={() => {
            jumpReport(rowData.reportUrl);
        }}>
                查看检测报告
              </a>
            </div>)}
        <div>
          <a onClick={() => {
            // dispatch.router.push({
            //   path: '/carManage/offerdetails',
            //   query: {
            //     id: rowData.auctionId,
            //   },
            // });
            showRecord({
                id: rowData.auctionId,
                type: 'offer',
            });
        }}>查看出价记录
          </a>
        </div>
        {roundStatus === 3 && rowData.auctionStatus === 50 && <div style={{
            display: 'flex',
            flexDirection: 'row',
        }}>
            <Authorized allow={'psgjb-cartransacpend-select'}>
              <a luban-id="PSGJB-CAR-DCJCL-CJ" onClick={() => {
            this.showConfirm(rowData);
        }}>
                成交
              </a>
            </Authorized>
            <Authorized allow={'psgjb-cartransacpend-select'}>
              <a luban-id="PSGJB-CAR-DCJCL-LP" onClick={() => {
            const { auctionId } = rowData;
            this.abortiveAuction(auctionId);
        }}>
                流拍
              </a>
            </Authorized>
          </div>}
      </div>);
    }
    // 流拍确认框
    abortiveAuction(auctionId) {
        Modal.confirm({
            title: '是否确认流拍？',
            content: '',
            onOk() {
                dispatch.carOperate.flowAuction({
                    auctionId,
                    callback: () => {
                        dispatch.session.getGoodsDetail({});
                    },
                });
            },
        });
    }
    // 成交确认框
    showConfirm(record) {
        const { auctionId, buyerCode } = record;
        dealCar({
            auctionIdStr: auctionId,
            buyerCode,
        }, () => {
            dispatch.session.getGoodsDetail({});
        });
    }
    render() {
        const { pageState } = getState().session;
        return (<div className={styles.table_btn_list}>
        {pageState !== 2 && this.renderSession()}
        {pageState === 2 && this.renderDetail()}
      </div>);
    }
}
export default TableCellOperate;
